import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import FilterInformeGerencial from 'views/reports/informeGerencial2/filterInformeGerencial2'; // Importing filter component
import TableInformeGerencial from 'views/reports/informeGerencial2/tableInformeGerencial2'; // Importing table component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the Informe Gerencial View.
 * @extends JetView
 */
export default class InformeGerencialView extends JetView {
    /**
     * Configures the UI components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration
        const toolbar = {
            view: 'toolbar', // Toolbar component
            id: 'toolbar',
            css: 'highlighted_header header6',
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'pager', // Pager component for navigation
                    id: 'pagerA',
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}',
                    autosize: false,
                    height: 35,
                    size: 10000,
                },
                {
                    view: 'richselect', // Dropdown for export options
                    name: 'Export',
                    id: 'Export',
                    width: 120,
                    placeholder: _('Exportar'), // Placeholder text
                    options: [
                        { id: '1', value: 'Excel' }, // Excel export option
                        { id: '2', value: 'PDF' }, // PDF export option
                    ],
                    on: {
                        onChange: function (value) {
                            // Event handler for export selection
                            if (value == 1) {
                                // Excel export
                                var table = $$('treetable'); // Reference to the table
                                for (var j = 0; j < table.config.columns.length; j++) {
                                    if (table.config.columns[j].exportType) {
                                        delete table.config.columns[j].format; // Remove format for export
                                    }
                                }
                                webix.toExcel(table, {
                                    // Export to Excel
                                    filename:
                                        'Virtualsoft - ' +
                                        new Date()
                                            .toLocaleString('en-GB', {
                                                hour12: true,
                                            })
                                            .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                            .replace(/[\/:]/g, '_')
                                            .toUpperCase() +
                                        ' - ' +
                                        ($$('treetable').count() > 0 ? '' : _('No hay datos - ')) +
                                        _('Informe Gerencial'),
                                });
                            } else {
                                if (value == 2) {
                                    // PDF export
                                    webix.toPDF($$('treetable'), {
                                        // Export to PDF
                                        filename:
                                            'Virtualsoft - ' +
                                            new Date()
                                                .toLocaleString('en-GB', {
                                                    hour12: true,
                                                })
                                                .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                                .replace(/[\/:]/g, '_')
                                                .toUpperCase() +
                                            ' - ' +
                                            ($$('treetable').count() > 0 ? '' : _('No hay datos - ')) +
                                            _('Informe Gerencial'),
                                        autowidth: true, // Auto width for PDF
                                    });
                                }
                            }
                            $$('Export').setValue(''); // Reset export selection
                        },
                    },
                },
            ],
        };
        const left = {
            css: 'int-left', // CSS class for left section
            rows: [
                {
                    view: 'toolbar', // Toolbar for the left section
                    css: theme,
                    elements: [
                        { view: 'label', label: _('Informe Gerencial') }, // Title label
                        {
                            type: 'wide',
                            css: 'close-bottom',
                            id: 'button-search', // Search button
                            cols: [
                                {
                                    view: 'icon',
                                    icon: 'wxi-search', // Search icon
                                    bottom: 20,
                                    right: 35,
                                    width: 30,
                                    height: 30,
                                    click: () => {
                                        $$('filterPopup').show(); // Show filter popup on click
                                    },
                                },
                            ],
                        },
                        {
                            type: 'wide',
                            css: 'close-bottom',
                            cols: [
                                {
                                    view: 'icon',
                                    icon: 'wxi-close', // Close icon
                                    bottom: 20,
                                    right: 35,
                                    width: 30,
                                    height: 30,
                                    click: () => this.show('/top/dashboard'), // Navigate to dashboard on click
                                },
                            ],
                        },
                    ],
                },
                FilterInformeGerencial, // Filter component
                TableInformeGerencial, // Table component
                toolbar, // Toolbar component
            ],
        };
        webix.ui.fullScreen(); // Set UI to full screen mode
        return {
            id: 'a5',
            type: 'clean',
            view: 'form', // Form view
            scroll: 'y', // Enable vertical scrolling
            rows: [
                {
                    responsive: 'a5',
                    type: 'wide',
                    cols: [left], // Left section with components
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up responsive behavior.
     * @param {Object} grid - The grid component.
     */
    init(grid) {
        webix.ready(function () {
            if (screen.width < 500 || screen.height < 500) {
                $$('toolbar').hide(); // Hide toolbar on small screens
            }
            if (screen.width > 500 && screen.height > 500) {
                $$('button-search').hide(); // Hide search button on larger screens
            }
        });
    }
}

// FILE DOCUMENTED
